import { REQUEST } from "../constants"

export default function getOutgoingShipments(storeId, shipments) {
  if (storeId === undefined) return shipments
  return shipments.filter(shipment => {
    return shipment.origin.id === storeId && shipment.status !== REQUEST
  })
}
